import { Reveal } from "./Reveal";

export const CLIENT_LOGOS = [
  { src: "/assets/clients/cruden-white.png", name: "Cruden Homes" },
  { src: "/assets/clients/buccleuch-white.png", name: "Buccleuch" },
  { src: "/assets/clients/edinburgh-council-white.png", name: "The City of Edinburgh Council" },
  { src: "/assets/clients/urban-civic-white.png", name: "Urban&Civic" },
  { src: "/assets/clients/aeg-white.png", name: "AEG" },
  { src: "/assets/clients/dio-white.png", name: "Defence Infrastructure Organisation" },
  { src: "/assets/clients/loch-lomond-white.png", name: "Loch Lomond & The Trossachs National Park" },
  { src: "/assets/clients/cannon-kirk-white.png", name: "Cannon Kirk Homes" },
  { src: "/assets/clients/partner-white.png", name: "Industry partner" },
];

const ClientLogos = ({ testid = "client-logo-strip" }) => (
  <Reveal delay={0.15}>
    <div className="mt-12 flex flex-wrap items-center justify-center gap-x-12 gap-y-8" data-testid={testid}>
      {CLIENT_LOGOS.map((c) => (
        <img
          key={c.src}
          src={c.src}
          alt={c.name}
          title={c.name}
          data-testid={`client-logo-${c.src.split("/").pop().replace("-white.png", "")}`}
          className="h-9 sm:h-10 w-auto max-w-[180px] object-contain opacity-60 hover:opacity-100 transition-opacity duration-300"
        />
      ))}
    </div>
  </Reveal>
);

export default ClientLogos;
